var modal = document.querySelector(".size_modal");
var trigger = document.querySelector(".size_guide_button");
var closeButton = document.querySelector(".close-size-button");

function toggleModal() {
    modal.classList.toggle("show-size-modal");
    document.body.classList.toggle("modal-open");
}

function windowOnClick(event) {
    if (event.target === modal) {
        toggleModal();
    }
}

if(trigger) trigger.addEventListener("click", toggleModal);
if(closeButton) closeButton.addEventListener("click", toggleModal);
window.addEventListener("click", windowOnClick);


// let findWislistBtnInterval = setInterval(wishListBtn, 500); 
// function wishListBtn() {
//   if(document.querySelector("wishlist-button-block").querySelector('[type="button"]')){    
//     document.querySelector(".wishlist_button").addEventListener("click",function(Element){
//       Element.currentTarget.classList.toggle('active')
//       document.querySelector("wishlist-button-block").querySelector('[type="button"]').click();
//     })  
//     if(document.querySelector("wishlist-button-block").querySelector('[type="button"]').getAttribute('aria-label') == 'In Wishlist'){
//       document.querySelector(".wishlist_button").classList.add('active');
//     }
//      clearInterval(findWislistBtnInterval)
//   }
// }

let findStoreAvailabilityInterval = setInterval(StoreAvailability, 800);
function StoreAvailability() {
if(document.querySelector('.slideout__trigger-store-availability')){
  document.querySelector('.slideout__trigger-store-availability').addEventListener('click',function(e){
    e.preventDefault();
    console.log(document.querySelector('.store-availabilities-modal'))
    if(document.querySelector('.store-availabilities-modal')) document.querySelector('.store-availabilities-modal').classList.toggle('active-store');
  })  
  clearInterval(findStoreAvailabilityInterval)
}
}

// sticky ATC button
// function setSectionHeight() {
//   let section = document.querySelector('.header-group'); 
//   if (!section) {
//     console.error('Section element not found. Check the class name.');
//     return;
//   }

//   let sectionHeight = section.offsetHeight + 'px';
//   document.documentElement.style.setProperty('--header-group-height', sectionHeight);
  
// }

// setSectionHeight();

// window.addEventListener('resize', setSectionHeight);
// window.addEventListener('scroll', setSectionHeight);


// function setWindowWidth() {
//   let screenWidth = window.innerWidth;
//   document.documentElement.style.setProperty('--window-width', `${screenWidth}px`);
  
// }
// setWindowWidth();
// window.addEventListener('resize', setWindowWidth);

// window.addEventListener("scroll", stickyATC);


// function stickyATC(){

//   const form = document.querySelector(".js-prod-form-submit");
//   // console.log("form",form);

//   if(!form) return;
//   const stickyatc = document.querySelector(".product__section--buttons-sticky");
//   // console.log("stickyatc :  ", stickyatc);
  
//   const gallery = document.querySelector(".product__section-images");
//   const stopSection = document.querySelector("#footer-wrapper");
//   const placeholder = document.getElementById("atc-placeholder");
//   const atcButton = document.querySelector(".atcButton")
  
//   // console.log("stopSection",gallery,placeholder,stopSection);
//   if(!gallery) return;

//   const galleryBottom = gallery.getBoundingClientRect().bottom;
//   const stopTop = stopSection ? stopSection.getBoundingClientRect().top : 99999;

//   if(galleryBottom < 0 && stopTop > window.innerHeight){
//       stickyatc.classList.remove("hide");  
//       stickyatc.classList.add("show");
//   }
//   else{
//       stickyatc.classList.remove("show");
//       stickyatc.classList.add("hide");
//   }

// }
// const mainATC   = document.getElementById("addToCart");
// const stickyATCButton = document.getElementById("stickyAddToCart");

// if (!mainATC || !stickyATCButton) return;

// stickyATCButton.addEventListener("click", function (e) {
//   e.preventDefault();
//   mainATC.click();
// });

// function syncATCState() {

//   if (mainATC.value) {
//     stickyATCButton.innerText = mainATC.value;
//   }

//   stickyATCButton.disabled = mainATC.disabled;

//   stickyATCButton.className = mainATC.className
//     .replace('js-ajax-submit', '') + ' sticky-atc-btn';
// }

// syncATCState();

// const observer = new MutationObserver(syncATCState);

// observer.observe(mainATC, {
//   attributes: true,
//   attributeFilter: ['class', 'disabled', 'value']
// });

// document.querySelector('a[href="#product__section-details"]')
// ?.addEventListener('click', function (e) {
//   e.preventDefault();

//   document
//     .getElementById('product__section-details')
//     ?.scrollIntoView({ behavior: 'smooth' });
// });
// document.addEventListener("DOMContentLoaded", function () {



// });

/* ================================
   HEADER HEIGHT + WINDOW WIDTH
================================ */

function setSectionHeight() {
  const section = document.querySelector('.header-group');
  if (!section) return;

  document.documentElement.style.setProperty(
    '--header-group-height',
    section.offsetHeight + 'px'
  );
}

function setWindowWidth() {
  document.documentElement.style.setProperty(
    '--window-width',
    window.innerWidth + 'px'
  );
}

setSectionHeight();
setWindowWidth();

window.addEventListener('resize', setSectionHeight);
window.addEventListener('resize', setWindowWidth);


/* ================================
   STICKY ATC VISIBILITY
================================ */

const stickyatc = document.querySelector(".product__section--buttons-sticky");
const gallery = document.querySelector(".product__section-images");
const stopSection = document.querySelector("#footer-wrapper");

function stickyATC() {
  if (!stickyatc || !gallery) return;

  const galleryBottom = gallery.getBoundingClientRect().bottom;
  const stopTop = stopSection
    ? stopSection.getBoundingClientRect().top
    : Number.POSITIVE_INFINITY;

  if (galleryBottom < 0 && stopTop > window.innerHeight) {
    stickyatc.classList.add("show");
    stickyatc.classList.remove("hide");
  } else {
    stickyatc.classList.remove("show");
    stickyatc.classList.add("hide");
  }
}

window.addEventListener("scroll", stickyATC);


/* ================================
   STICKY ATC BUTTON SYNC
================================ */

const mainATC = document.getElementById("addToCart");
const stickyATCButton = document.getElementById("stickyAddToCart");

if (mainATC && stickyATCButton) {

  stickyATCButton.addEventListener("click", function (e) {
    e.preventDefault();
    mainATC.click();
  });

  function syncATCState() {

    if (mainATC.value) {
      stickyATCButton.innerText = mainATC.value;
    }

    stickyATCButton.disabled = mainATC.disabled;

    stickyATCButton.className =
      mainATC.className.replace('js-ajax-submit', '').trim() +
      ' sticky-atc-btn';
  }

  syncATCState();

  const observer = new MutationObserver(syncATCState);

  observer.observe(mainATC, {
    attributes: true,
    attributeFilter: ['class', 'disabled', 'value']
  });
}


/* ================================
   SMOOTH SCROLL
================================ */

const detailsLink = document.querySelector('a[href="#product__section-details"]');

if (detailsLink) {
  detailsLink.addEventListener('click', function (e) {
    e.preventDefault();

    const target = document.getElementById('product__section-details');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  });
}

// product reccomend add in search
(function () {
  function initSearchRecommend() {
    const input = document.querySelector('.searchbox__input');
    const recommended = document.getElementById('recommended-products');
    const searchBtn = document.getElementById('search_button');

    // console.log("input:", input);
    // console.log("recommended:", recommended);
    // console.log("searchBtn:", searchBtn);

    if (!input || !recommended || !searchBtn) return false;

    if (input.value.trim() === '') {
      recommended.classList.remove('hide');
      searchBtn.disabled = true;
    }

    input.addEventListener('input', function () {
      const isEmpty = this.value.trim() === '';

      recommended.classList.toggle('hide', !isEmpty);

      searchBtn.disabled = isEmpty;
    });

    return true;
  }

  const interval = setInterval(function () {
    if (initSearchRecommend()) {
      clearInterval(interval);
    }
  }, 300);
})();
